import { render, staticRenderFns } from "./ExternalApiConfig.vue?vue&type=template&id=af200c82"
import script from "./ExternalApiConfig.vue?vue&type=script&lang=js"
export * from "./ExternalApiConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af200c82')) {
      api.createRecord('af200c82', component.options)
    } else {
      api.reload('af200c82', component.options)
    }
    module.hot.accept("./ExternalApiConfig.vue?vue&type=template&id=af200c82", function () {
      api.rerender('af200c82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ExternalApiConfig/ExternalApiConfig.vue"
export default component.exports